<template src='./ZoneManagement.html'></template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("zone");
import $ from "jquery";
//import template from "@/components/CommandCellTemplate.vue";
// import kendo from "@progress/kendo-ui";
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";

export default {
  data: function() {
    return {
      template:
        "#: item.name #" +
        "<a class='nt-trash-2-fill ml-3' value='#:item.name#' id='#:item.id #' name='close' ></a>" +
        "<a class='nt-icons nt-edit-fill ml-2' value='#:item.name#' id='#:item.id #' name='edit'></a>",
      // template: CommandCell,
      zoneData: { name: null },
      // localDataSource: [],
      isParent: true,
      isedit: false,
      isShow: false,
      model: { name: "SET AS PARENT", id: 0 }
    };
  },
  mounted() {},
  methods: {
    clickVal(e) {
      let id = e.target.id;

      let name;
      if (id) {
        name = document.getElementById(id).getAttribute("value");
      }

      this.zoneData.name = name ? name : null;
      this.zoneData.editId = id;
      if (e.target["name"] == "close") {
        this.$store.dispatch("zone/removeZone", id).then(async () => {
          await this.$store.dispatch("zone/getnewZone").then(async () => {
            this.data = await this.$store.getters["zone/zoneMngt"];
          });
          //
          this.closeWindow();
        });
      }
      if (e.target["name"] == "edit") {
        this.isedit = true;
        this.openWindow();
      }
    },
    Select(e) {
      var tree = $("#treeview").data("kendoTreeView");
      //
      let ID = tree.dataItem(tree.parent(e.node));
      this.model = ID ? { id: ID.id } : { id: 0 };
      this.zoneData.id = ID ? ID.id : 0;
    },
    openForm() {
      this.isedit = false;
      this.zoneData.name = null;
      this.model = { id: "" };

      this.openWindow();
    },
    openWindow() {
      // this.isedit = false;
      this.isShow = false;
      var window = this.$refs.windowRef.kendoWidget();
      window.center().open();
    },
    closeWindow() {
      this.isedit = false;
      var window = this.$refs.windowRef.kendoWidget();
      window.center().close();
    },
    edit() {
      // this.isedit = true;
      // console.log(this.zoneData);
      // this.zoneData.name = this.zoneData.text;
      // this.zoneData.editId = this.zoneData.id;
    },
    remove() {
      // this.$store
      //   .dispatch("zone/removeZone", this.zoneData.id)
      //   .then(async () => {
      //     await this.$store.dispatch("zone/getnewZone").then(async () => {
      //       this.data = await this.$store.getters["zone/zoneMngt"];
      //     });
      //     //
      //     this.closeWindow();
      //   });
    },
    AddZone() {
      if (this.zoneData.name) {
        let data = {
          Name: this.zoneData.name,
          ParentId: this.zoneData.id !== 0 ? this.zoneData.id : null
        };
        this.$store.dispatch("zone/addZone", data).then(async () => {
          await this.$store.dispatch("zone/getnewZone").then(async () => {
            this.data = await this.$store.getters["zone/zoneMngt"];
          });
          //
          this.closeWindow();
        });
      }
    },
    updateZone() {
      let data = {};
      if (this.zoneData.name) {
        if (this.zoneData.editId === this.zoneData.id) {
          data = {
            Name: this.zoneData.name,

            ParentID: null
          };
        } else {
          data = {
            Name: this.zoneData.name,

            ParentID: this.zoneData.id !== 0 ? this.zoneData.id : null
          };
        }

        this.$store
          .dispatch("zone/updateZone", { id: this.zoneData.editId, Data: data })
          .then(async () => {
            await this.$store.dispatch("zone/getnewZone").then(async () => {
              this.data = await this.$store.getters["zone/zoneMngt"];
            });
          });
        this.closeWindow();
      }
    },
    ChangeZone(e) {
      this.zoneData.id = e.sender._values[0];
      // this.zoneData.text = e.sender._values[0].name;
      this.model = {
        id: e.sender._values[0]
      };
      this.isShow = this.zoneData.id !== 0 ? true : false;
    },
    addParent() {
      this.zoneData = {};
      this.isParent = false;
    },
    async getDataOnload() {
      this.$store.dispatch("zone/getnewZone").then(async () => {});
    },
    Close(e) {
      console.log("click event", e);
    }, // getLoop(item) {

    // }
    onDrag(e) {
      var treeview = this;
      var t = $;
      var sourceUid = t(e.sourceNode).data("uid");
      var destinationUid = t(e.destinationNode).data("uid");

      var source = treeview.localDataSource.getByUid(sourceUid);
      var destination = treeview.localDataSource.getByUid(destinationUid);

      let data = {
        id: source.id,
        Name: source.namw,
        ParentID: destination.id
      };
      this.$store.dispatch("zone/updateZone", data).then(async () => {});
    }
  },
  computed: {
    ...mapState({
      localDataSource: state => state.zones,
      Dropzones: state => state.Dropzones
    }),
    modelVal() {
      return this.model.id;
    }
    // drpdownData() {
    //   return this.localDataSource.shift({ text: "set as parent" });
    // }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>
<style>
#treeview-left,
#treeview-right {
  overflow: visible;
}

.k-treeview .k-item {
  margin: 12px;
}
</style>